(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ai_gen_block_1ee8dc1"] && !Shopify.designMode) return;
  try {
    // Hero images default to loading="lazy" so below-fold heroes don't compete
  // for bandwidth with the LCP. But native lazy's trigger threshold is too
  // tight on fast desktops — users see a blank slot for ~1 viewport scroll
  // before the next hero pops in. We widen the threshold to "1 viewport below"
  // by stripping the lazy attribute once an image enters that zone, which
  // makes the browser fetch right away.
  if (!window.__heroLazyApproachInit) {
    window.__heroLazyApproachInit = true;
    const setupHeroLazyApproach = () => {
      if (!('IntersectionObserver' in window)) return;
      const io = new IntersectionObserver((entries) => {
        for (const e of entries) {
          if (e.isIntersecting) {
            const img = e.target;
            // Removing the loading attribute makes it eager — browser fetches now.
            img.removeAttribute('loading');
            // If a previous lazy state stopped srcset evaluation, kick it.
            if (img.dataset.heroSrcset && !img.srcset) img.srcset = img.dataset.heroSrcset;
            io.unobserve(img);
          }
        }
      }, { rootMargin: '0px 0px 100% 0px' });
      const observe = () => {
        document.querySelectorAll('img.ai-hero-banner__media[loading="lazy"], img.ai-hero-banner__video-poster[loading="lazy"]').forEach((img) => io.observe(img));
      };
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', observe, { once: true });
      } else {
        observe();
      }
    };
    setupHeroLazyApproach();
  }

  (function () {
    if (customElements.get('edge-to-edge-hero')) return;

    // ---- Sticky text: pin the text block to the viewport bottom while the
    // hero's foot is below it, then let it settle. One rAF-throttled handler
    // for every hero on the page; an IntersectionObserver keeps the working
    // set to heroes near the viewport. Writes only --hero-lift (see CSS).
    const liftHeroes = new Set();
    let liftRaf = 0;
    const updateLifts = () => {
      liftRaf = 0;
      const vh = window.innerHeight || document.documentElement.clientHeight;
      liftHeroes.forEach((hero) => {
        const content = hero.content;
        if (!content) return;
        const r = hero.getBoundingClientRect();
        let lift = 0;
        const overhang = r.bottom - vh; // hero pixels still below the viewport bottom
        const inset = pinInsetFor(r.height);
        if (overhang + inset > 0 && r.top < vh) {
          // Rest --hero-rest above the foot until that point reaches the pin line, then pin.
          const rest = parseFloat(hero.style.getPropertyValue('--hero-rest')) || r.height / 2;
          lift = Math.min(overhang + inset, rest);
        }
        // Move the whole pinned layer (same as the compositor path) so the
        // background panel parked below the text stays clipped by the layer.
        const pin = hero.querySelector('[data-pin]');
        const next = lift > 0.5 ? `translate3d(0, -${Math.round(lift)}px, 0)` : '';
        if (pin && pin.style.transform !== next) pin.style.transform = next;
        hero.style.setProperty('--hero-lift', '0px');
      });
    };
    const scheduleLifts = () => { if (!liftRaf) liftRaf = requestAnimationFrame(updateLifts); };
    // Pin line offset above the viewport bottom. 0 = pin at the edge (chosen:
    // matches how it reads in Safari on a MacBook). If ever needed, a value of
    // e.g. 0.1 pins up to 10vh above the edge, never more than the hero
    // overhangs the viewport (so a hero that fits still settles at once).
    const PIN_INSET_RATIO = 0;
    // All sticky-text heroes on the page (see registerLift) and the current
    // eased sticky-bar offset in px (see atcSync below).
    const allHeroes = new Set();
    let barCur = 0; // how much of the sticky bar is showing, 0…1 (--hero-bar)
    const ATC_TUCK = 1; // px the docked text tucks under the bar (mirrors the CSS)
    // The bar's CSS height for the JS path (see --satc-box-height).
    let barProbe = null;
    const barBoxHeight = () => {
      if (!barProbe) { barProbe = document.createElement('div'); barProbe.style.cssText = 'position:fixed;top:0;left:0;width:0;height:var(--satc-box-height,0px);pointer-events:none;visibility:hidden'; document.body.append(barProbe); }
      return barProbe.getBoundingClientRect().height;
    };
    // Small-viewport probe for the JS path (mirrors the CSS 100dvh − 100svh inset).
    let svhProbe = null;
    const smallViewportHeight = () => {
      if (!svhProbe) { svhProbe = document.createElement('div'); svhProbe.style.cssText = 'position:fixed;top:0;left:0;width:0;height:100svh;pointer-events:none;visibility:hidden'; document.body.append(svhProbe); }
      return svhProbe.offsetHeight || window.innerHeight;
    };
    const pinInsetFor = (heroHeight) => {
      const vh = window.innerHeight || document.documentElement.clientHeight;
      if (PIN_INSET_RATIO && window.innerWidth >= 990) return Math.round(Math.min(vh * PIN_INSET_RATIO, Math.max(0, heroHeight - vh)));
      // The sticky engine follows the live viewport edge natively: no toolbar-stable term.
      return Math.max(0, (stickyPin ? 0 : (vh - smallViewportHeight()) * (1 - barCur)) + (barCur ? Math.max(0, barBoxHeight() - ATC_TUCK) * barCur : 0));
    };
    const liftObserver = 'IntersectionObserver' in window
      ? new IntersectionObserver((entries) => {
          entries.forEach((e) => {
            if (e.isIntersecting) liftHeroes.add(e.target);
            else { liftHeroes.delete(e.target); const pin = e.target.querySelector('[data-pin]'); if (pin) pin.style.transform = ''; }
          });
          scheduleLifts();
        }, { rootMargin: '25% 0px 25% 0px' })
      : null;
    // Browsers with scroll-driven animations pin on the compositor (see CSS);
    // the JS lift is only for the rest.
    // ?hero_pin=js|css forces the engine for this page load (A/B on device).
    const pinMode = (location.search.match(/[?&]hero_pin=(js|css|sticky)/) || [])[1];
    // Default engine: native sticky (see the stylesheet). It needs overflow: clip
    // on the hero (overflow: hidden would trap the sticky box); browsers without
    // it fall back to the scroll-driven or JS engines below. ?hero_pin=css|js|sticky
    // forces one for this page load.
    // Support alone is not enough: Firefox before 128 knows both properties yet
    // leaves this engine's sticky line unstuck (measured on real Firefox 115,
    // 117 and 121, 2026-10-12). So build the engine's own structure once, in a
    // tiny hidden scroller, and check the line really holds at the bottom edge.
    const stickyHolds = () => {
      try {
        const box = document.createElement('div');
        box.style.cssText = 'position:fixed;left:-9999px;top:0;width:50px;height:100px;overflow:auto;visibility:hidden;pointer-events:none';
        box.innerHTML = '<div style="height:150px"></div><div style="position:relative;height:300px;overflow:clip"><div style="position:absolute;left:0;right:0;bottom:0;height:120px;display:flex;flex-direction:column"><div style="position:sticky;bottom:0;height:0;margin-top:auto"></div></div></div><div style="height:300px"></div>';
        (document.body || document.documentElement).appendChild(box);
        box.scrollTop = 280;
        const line = box.children[1].firstElementChild.firstElementChild;
        const at = line.getBoundingClientRect().bottom - box.getBoundingClientRect().top;
        box.remove();
        return Math.abs(at - 100) < 2; // stuck: 100 (the scroller's bottom edge); unstuck: 170
      } catch (e) {
        return false;
      }
    };
    const stickyPin = pinMode ? pinMode === 'sticky' : !!(window.CSS && CSS.supports && CSS.supports('position', 'sticky') && CSS.supports('overflow', 'clip')) && stickyHolds();
    const compositorPin = pinMode === 'js' ? false : pinMode === 'css' ? true : !!(window.CSS && CSS.supports && CSS.supports('animation-timeline: view()'));
    const nearObserver = 'IntersectionObserver' in window
      ? new IntersectionObserver((entries) => entries.forEach((e) => e.target.classList.toggle('is-near', e.isIntersecting)), { rootMargin: '100% 0px 100% 0px' })
      : null;
    const registerLift = (hero) => {
      allHeroes.add(hero);
      if (barCur) hero.style.setProperty('--hero-bar', String(Math.round(barCur * 1000) / 1000));
      if (stickyPin) {
        // The pin layer hangs from the sticky anchor at the hero's own height.
        hero.style.setProperty('--hero-h', (Math.round(hero.getBoundingClientRect().height * 100) / 100) + 'px');
        hero.classList.add('pin-sticky');
        document.documentElement.classList.add('vb-pin-sticky');
        return;
      }
      if (nearObserver) nearObserver.observe(hero); else hero.classList.add('is-near');
      if (compositorPin) return;
      hero.classList.add('pin-js');
      if (liftObserver) liftObserver.observe(hero); else liftHeroes.add(hero);
      scheduleLifts();
    };
    window.addEventListener('scroll', scheduleLifts, { passive: true });
    window.addEventListener('resize', scheduleLifts);

    // One shared, frame-coalesced resize handler for every hero on the page.
    // Chrome on iOS resizes the page on EVERY FRAME while its toolbars slide
    // (height only), and each hero used to re-measure and restyle itself on
    // every one of those events, one forced layout per hero. A hero's own
    // layout depends only on its box and the page width, so heroes whose size
    // has not changed are skipped; the scroll-position checks still run,
    // because their 45%-of-viewport line has moved.
    const resizeHeroes = new Set();
    let resizeRaf = 0;
    const runResize = () => {
      resizeRaf = 0;
      const vw = window.innerWidth;
      const changed = [];
      resizeHeroes.forEach((hero) => {
        const sig = vw + 'x' + hero.offsetWidth + 'x' + hero.offsetHeight;
        if (sig !== hero.sizeSig_) { hero.sizeSig_ = sig; changed.push(hero); }
      });
      changed.forEach((hero) => hero.updatePositions());
      resizeHeroes.forEach((hero) => { if (hero.scrollChecks_) hero.scrollChecks_.forEach((check) => check()); });
    };
    window.addEventListener('resize', () => { if (!resizeRaf) resizeRaf = requestAnimationFrame(runResize); });

    // Sticky add-to-cart bar (PDP): ease --hero-bar between 0 and 1 as the bar
    // shows/hides (html.sticky-atc-visible, set by sticky-add-to-cart.js), so
    // the pin line slides up/down with it. Only the show/hide is JS; the bar's
    // height itself is pure CSS (see the stylesheet), so nothing here has to
    // chase it. Written on each hero (subtree recalc only), not <html>.
    const ATC_MS = 320;
    const atcEase = (t) => 1 - Math.pow(1 - t, 3);
    let barFrom = 0, barTo = 0, barT0 = 0, barRaf = 0;
    const barTarget = () => (document.documentElement.classList.contains('sticky-atc-visible') ? 1 : 0);
    const barApply = () => {
      const v = String(Math.round(barCur * 1000) / 1000);
      allHeroes.forEach((hero) => hero.style.setProperty('--hero-bar', v));
      scheduleLifts();
    };
    const barStep = (now) => {
      barRaf = 0;
      const t = Math.min(1, (now - barT0) / ATC_MS);
      barCur = barFrom + (barTo - barFrom) * atcEase(t);
      barApply();
      if (t < 1) barRaf = requestAnimationFrame(barStep);
    };
    const barSync = () => {
      const target = barTarget();
      if (target === barTo) return;
      barFrom = barCur; barTo = target; barT0 = performance.now();
      if (!barRaf) barRaf = requestAnimationFrame(barStep);
    };
    if ('MutationObserver' in window) {
      new MutationObserver(barSync).observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
      barCur = barTo = barTarget();
    }

    // Diagnostics: ?hero_debug=1 draws a readout of the sticky-text inputs for
    // the first two heroes (viewport, geometry, rest/inset, live transform).
    if (/[?&]hero_debug=1/.test(location.search)) {
      const box = document.createElement('pre');
      box.style.cssText = 'position:fixed;top:8px;left:8px;z-index:2147483647;margin:0;padding:10px 12px;background:rgba(0,0,0,.85);color:#0f0;font:12px/1.4 ui-monospace,Menlo,monospace;pointer-events:none;white-space:pre-wrap;word-break:break-word;max-width:94vw;overflow:hidden;font-size:10px';
      document.body.append(box);
      const fmt = (n) => (typeof n === 'number' ? Math.round(n) : n);
      // Probes: viewport units, the bottom safe-area inset and the bar's CSS height, as the browser resolves them right now.
      const probe = (h) => { const d = document.createElement('div'); d.style.cssText = 'position:fixed;top:0;left:0;width:0;height:' + h + ';pointer-events:none;visibility:hidden'; document.body.append(d); return d; };
      const pSvh = probe('100svh'), pDvh = probe('100dvh'), pLvh = probe('100lvh'), pSafe = probe('env(safe-area-inset-bottom, 0px)'), pBox = probe('var(--satc-box-height, 0px)');
      const hist = []; let lastT = 0;
      const rng = (k, d) => { const v = hist.map((x) => x[k]).filter((x) => typeof x === 'number'); if (!v.length) return '-'; const a = Math.min(...v), b = Math.max(...v); return a.toFixed(d) + (b - a >= 0.05 ? '…' + b.toFixed(d) : ''); };
      const tick = () => {
        const vh = window.innerHeight, vw = window.innerWidth;
        const barEl = document.querySelector('sticky-add-to-cart'); const barRect = barEl && barEl.classList.contains('is-visible') ? barEl.getBoundingClientRect() : null; const barTop = barRect ? barRect.top : null;
        const now = performance.now(); const sample = { t: now, dt: lastT ? now - lastT : 0, ih: vh, dvh: pDvh.offsetHeight, svh: pSvh.offsetHeight, sb: pSafe.getBoundingClientRect().height, bh: barRect ? barRect.height : undefined, bt: barRect ? barRect.top : undefined }; lastT = now;
        const lines0 = [`svh ${sample.svh}  dvh ${sample.dvh}  lvh ${pLvh.offsetHeight}  innerH ${vh}  visualVP ${window.visualViewport ? Math.round(window.visualViewport.height) : '-'}  safeBottom ${sample.sb.toFixed(1)}  barTop ${barTop === null ? 'hidden' : barTop.toFixed(2)}  barH real ${barRect ? barRect.height.toFixed(2) : '-'} / css ${pBox.getBoundingClientRect().height.toFixed(2)}`];
        const visible = [...document.querySelectorAll('edge-to-edge-hero')].filter((h) => { const r = h.getBoundingClientRect(); return r.bottom > 0 && r.top < vh && h.querySelector('[data-pin]'); }).slice(0, 3);
        visible.forEach((h) => { const r = h.getBoundingClientRect(); const pr = h.querySelector('[data-pin]').getBoundingClientRect(); const lifted = r.bottom - pr.bottom; const rest = parseFloat(h.style.getPropertyValue('--hero-rest')) || 0; const docked = lifted > 0.5 && lifted < rest - 0.5; const gap = barTop === null ? null : barTop - pr.bottom; if (docked && gap !== null && sample.gap === undefined) sample.gap = gap; lines0.push(`ON SCREEN "${(h.querySelector('.ai-hero-banner__headline')?.textContent || '').trim().slice(0, 22)}" hero ${fmt(r.top)}→${fmt(r.bottom)} h ${r.height.toFixed(2)} sticky ${h.dataset.stickyText} bar ${h.style.getPropertyValue('--hero-bar') || '0'} offset ${getComputedStyle(h).getPropertyValue('--hero-atc-offset').trim()} lift ${lifted.toFixed(1)}/${fmt(rest)} ${docked ? 'DOCKED' : lifted < 0.5 ? 'settled' : 'resting'}  DOCK→BAR ${gap === null ? '-' : gap.toFixed(2)}`); });
        hist.push(sample); while (hist.length && hist[0].t < now - 8000) hist.shift();
        lines0.push(`LAST 8s: innerH ${rng('ih', 0)}  dvh ${rng('dvh', 0)}  svh ${rng('svh', 0)}  safeBottom ${rng('sb', 1)}  barH ${rng('bh', 1)}  barTop ${rng('bt', 1)}  DOCK→BAR ${rng('gap', 2)}  worstFrame ${Math.round(Math.max(0, ...hist.map((x) => x.dt)))}ms  mode ${stickyPin ? 'sticky' : compositorPin ? 'css' : 'js'}`);
        lines0.push('');
        const lines = lines0.concat([`viewport ${vw}x${vh} css px  dpr ${window.devicePixelRatio}  zoom? outer ${window.outerWidth}x${window.outerHeight}  scrollY ${fmt(scrollY)}  UA ${navigator.userAgent.match(/Chrome\/[\d.]+|Version\/[\d.]+ Safari|Firefox\/[\d.]+/)?.[0] || ''}`]);
        lines.push(`supports view(): ${!!(window.CSS && CSS.supports && CSS.supports('animation-timeline: view()'))}  compositorPin ${compositorPin}  scroller ${document.scrollingElement === document.documentElement ? 'html' : 'other'}  htmlOverflow ${getComputedStyle(document.documentElement).overflow}  bodyOverflow ${getComputedStyle(document.body).overflow}`);
        document.querySelectorAll('edge-to-edge-hero').forEach((h, i) => {
          if (i > 1) return;
          const pin = h.querySelector('[data-pin]'); if (!pin) return;
          const r = h.getBoundingClientRect(); const c = h.content ? h.content.getBoundingClientRect() : null; const cs = getComputedStyle(pin);
          const anim = pin.getAnimations()[0];
          const ct = anim && anim.currentTime; const prog = ct && typeof ct === 'object' ? ct.value.toFixed(1) + '%' : ct == null ? 'none' : String(ct);
          let ancestorScroller = 'none'; for (let e = h.parentElement; e && e !== document.documentElement; e = e.parentElement) { const o = getComputedStyle(e); if (/(auto|scroll|hidden)/.test(o.overflow + o.overflowY)) { ancestorScroller = e.tagName.toLowerCase() + (e.id ? '#' + e.id : '') + ' ' + o.overflow; break; } }
          lines.push(`hero${i + 1} top ${fmt(r.top)} h ${fmt(r.height)} bottom ${fmt(r.bottom)} | text top ${c ? fmt(c.top) : '-'} bottom ${c ? fmt(c.bottom) : '-'} (${c && c.bottom > vh ? 'CUT OFF' : 'on screen'}) | rest ${h.style.getPropertyValue('--hero-rest') || '?'} inset ${getComputedStyle(h).getPropertyValue('--hero-pin-inset').trim()} lift ${h.style.getPropertyValue('--hero-lift') || '-'}`);
          lines.push(`      pin transform ${cs.transform}  range [${cs.animationRange || cs.getPropertyValue('animation-range')}]  timeline ${cs.animationTimeline || cs.getPropertyValue('animation-timeline')}  anim ${anim ? anim.playState + ' ' + prog : 'NONE'}  overflow-ancestor ${ancestorScroller}`);
        });
        box.textContent = lines.join('\n');
        requestAnimationFrame(tick);
      };
      tick();
    }

    class EdgeToEdgeHero extends HTMLElement {
      constructor() {
        super();
        this.isHovering = false;
        this.isMobileExpanded = false;
      }

      connectedCallback() {
        this.videos = this.querySelectorAll('video');
        const shouldAutoplay = this.dataset.videoAutoplay === 'true';

        this.classList.toggle('video-click-to-play', !shouldAutoplay);

        const syncVideoOverlays = () => {
          if (shouldAutoplay) return;
          const wraps = this.querySelectorAll('[data-video-wrap]');
          let anyPlaying = false;
          wraps.forEach((wrap) => {
            // Target the MAIN video specifically — the cover loop is also a
            // <video> inside the same wrap and would otherwise be picked first.
            const v = wrap.querySelector('.ai-hero-banner__video');
            if (!v) return;
            const paused = v.paused || v.ended;
            wrap.classList.toggle('is-paused', paused);
            if (!paused) anyPlaying = true;
          });
          this.classList.toggle('video-playing', anyPlaying);
          // Sticky: once any video has played, hover-zone stays disabled so
          // the controls remain interactive even after the user pauses.
          if (anyPlaying) this.classList.add('video-engaged');
        };
        syncVideoOverlays();

        /* Text label mode: a pause after the film has played flashes the
           pause word before the play word settles (see CSS .is-flash). The
           flash length comes from --hero-vlabel-flash. Not for `ended`. */
        const textLabel = this.dataset.videoLabel === 'text';
        const flashMs = textLabel ? (parseInt(getComputedStyle(this).getPropertyValue('--hero-vlabel-flash'), 10) || 700) : 0;
        const flashTimers = new WeakMap();
        const holdPause = this.dataset.videoLabelPause === 'hold';
        // Films that have had a play event. `played` stays empty if the visitor
        // pauses before the first frame advances (slow connection), so hold
        // mode keys off this instead.
        const started = new WeakSet();
        const flashPause = (v) => {
          if (!textLabel) return;
          const wrap = v.closest('[data-video-wrap]');
          if (!wrap || v.ended) return;
          if (holdPause) { if (started.has(v)) wrap.classList.add('is-held'); return; }
          if (v.played.length === 0) return;
          clearTimeout(flashTimers.get(wrap));
          wrap.classList.remove('is-flash');
          void wrap.offsetWidth; // restart the animation on rapid re-pauses
          wrap.classList.add('is-flash');
          flashTimers.set(wrap, setTimeout(() => wrap.classList.remove('is-flash'), flashMs));
        };
        const clearFlash = (v) => {
          if (!textLabel) return;
          const wrap = v.closest('[data-video-wrap]');
          if (!wrap) return;
          clearTimeout(flashTimers.get(wrap));
          wrap.classList.remove('is-flash', 'is-held');
        };

        this.videos.forEach((v) => {
          // Cover loops play continuously and shouldn't drive engagement state.
          if (!v.classList.contains('ai-hero-banner__video')) return;
          v.addEventListener('play', (e) => { started.add(e.target); clearFlash(e.target); syncVideoOverlays(); });
          v.addEventListener('pause', (e) => { syncVideoOverlays(); flashPause(e.target); });
          v.addEventListener('ended', syncVideoOverlays);
          v.addEventListener('loadeddata', syncVideoOverlays);
        });

        // Cover-loop swap: when the main click-to-play video actually starts
        // rendering frames (`playing` event, not `play`), hide the cover so
        // the swap happens between real frames — no black-frame flicker even
        // if the main video is mid-buffer when the user clicks.
        if (!shouldAutoplay) {
          this.querySelectorAll('[data-video-wrap]').forEach((wrap) => {
            const cover = wrap.querySelector('.ai-hero-banner__cover-video');
            const main = wrap.querySelector('.ai-hero-banner__video');
            // .has-poster wraps also need .is-engaged to reveal the video.
            if (!main || (!cover && !wrap.classList.contains('has-poster'))) return;
            main.addEventListener('playing', () => {
              wrap.classList.add('is-engaged');
              if (cover) { try { cover.pause(); } catch (e) {} }
            }, { once: true });
          });
        }

        /* Autoplay handled by the lazy section manager in layout/theme.liquid.
           It starts muted-loop videos on first intersection so Safari doesn't
           pre-download them during HTML parse (preload=metadata is ignored when
           autoplay is declared on the element). */

        /* Click-to-start (2026-07-29): the play-icon overlay is decorative
           (pointer-events: none) and browsers don't reliably toggle playback
           on video-body clicks — Safari never does, Chrome ignores them while
           metadata is still loading. Before first engagement, any click on a
           click-to-play wrap explicitly starts the main video; the click is a
           real user gesture so play() with sound is permitted. After
           engagement the native controls own all clicks. */
        if (!shouldAutoplay) {
          this.addEventListener('click', (e) => {
            const wrap = e.target.closest('[data-video-wrap]');
            if (!wrap || !this.contains(wrap)) return;
            if (wrap.classList.contains('is-engaged')) return;
            const v = wrap.querySelector('.ai-hero-banner__video');
            /* Two guards make this cooperate with the browser's native
               click handling in every ordering:
               1. v.played: a video with ANY played time is the user's to
                  control (native pause acts inside the shadow DOM before
                  this bubbled click arrives — "paused" alone would restart
                  a just-paused video).
               2. setTimeout(0): Chrome toggles play/pause on video-body
                  clicks as the click's DEFAULT ACTION, which runs after
                  this handler. Starting the video here directly made the
                  native toggle flip it straight back to paused (desktop
                  first-click dead; Safari has no body toggle, so iPhone
                  worked). Deferring past the default action means: if the
                  native toggle started it, we do nothing; if it did
                  nothing (e.g. metadata still loading), we start it. The
                  click's transient user activation still covers the
                  deferred play(), so sound is permitted. */
            if (v && v.paused && v.played.length === 0 && this.dataset.videoLabel !== 'text') {
              setTimeout(() => {
                if (v.paused && v.played.length === 0) {
                  v.play().catch(() => {});
                }
              }, 0);
            }
          });
        }

        /* Label-style films (no native controls): a tap anywhere on the film
           toggles it — play when paused or finished, pause when playing.
           The first-play handler above also fires on the first tap; it
           defers its play() and finds the film already playing, so the two
           never double up. Keyboard: the wrap is a focusable button
           (Enter / Space), its aria-label follows the state. */
        if (!shouldAutoplay && this.dataset.videoLabel === 'text') {
          this.querySelectorAll('[data-video-wrap]').forEach((wrap) => {
            const v = wrap.querySelector('.ai-hero-banner__video');
            if (!v) return;
            const label = () => wrap.setAttribute('aria-label', v.paused || v.ended ? 'Play video' : 'Pause video');
            wrap.setAttribute('role', 'button');
            wrap.setAttribute('tabindex', '0');
            label();
            ['play', 'pause', 'ended'].forEach((t) => v.addEventListener(t, label));
            const toggle = () => { if (v.paused || v.ended) v.play().catch(() => {}); else v.pause(); };
            wrap.addEventListener('click', (e) => { if (e.target.closest('a, button, .ai-hero-banner__video-progress, .ai-hero-banner__video-controls')) return; toggle(); });
            wrap.addEventListener('keydown', (e) => {
              if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(); }
              // Arrow keys skip 5s once the film has started (same as drag to skip)
              if ((e.key === 'ArrowLeft' || e.key === 'ArrowRight') && wrap.classList.contains('is-started') && v.duration > 0) {
                e.preventDefault();
                v.currentTime = Math.max(0, Math.min(v.duration - 0.1, v.currentTime + (e.key === 'ArrowRight' ? 5 : -5)));
              }
            });
            /* Progress line: follows currentTime every frame while playing,
               once on pause / seek; shown from the first play, hidden again
               when the film ends (it returns to its Play state). */
            if (this.hasAttribute('data-video-progress')) {
              const bar = document.createElement('div');
              bar.className = 'ai-hero-banner__video-progress';
              bar.setAttribute('aria-hidden', 'true');
              bar.innerHTML = '<span class="ai-hero-banner__video-progress-line"><span class="ai-hero-banner__video-progress-buffered"></span><span class="ai-hero-banner__video-progress-fill"></span><span class="ai-hero-banner__video-progress-dot"></span></span>';
              wrap.appendChild(bar);
              const buffered = bar.querySelector('.ai-hero-banner__video-progress-buffered');
              const fill = bar.querySelector('.ai-hero-banner__video-progress-fill');
              const dot = bar.querySelector('.ai-hero-banner__video-progress-dot');
              let raf = 0;
              let scrubTo = null; // 0..1 while dragging: draw the finger, not the (lagging) video
              let onPaint = null; // control bar timer follows the finger while dragging
              const paint = (f) => { fill.style.transform = 'scaleX(' + f + ')'; dot.style.left = (f * 100) + '%'; if (onPaint) onPaint(f); };
              const draw = () => {
                const d = v.duration;
                if (scrubTo === null) paint(d > 0 ? Math.min(v.currentTime / d, 1) : 0);
                // Loaded-ahead: the buffered range that contains the playhead
                let end = 0;
                for (let i = 0; i < v.buffered.length; i++) {
                  if (v.buffered.start(i) <= v.currentTime + 0.5 && v.buffered.end(i) >= v.currentTime) end = v.buffered.end(i);
                }
                buffered.style.transform = 'scaleX(' + (d > 0 ? Math.min(end / d, 1) : 0) + ')';
              };
              const loop = () => { draw(); raf = v.paused ? 0 : requestAnimationFrame(loop); };
              v.addEventListener('play', () => { wrap.classList.add('is-started'); if (!raf) raf = requestAnimationFrame(loop); });
              ['pause', 'seeked', 'timeupdate', 'progress'].forEach((t) => v.addEventListener(t, draw));
              v.addEventListener('ended', () => { cancelAnimationFrame(raf); raf = 0; wrap.classList.remove('is-started'); });

              /* Drag to skip: tap or drag on the strip seeks; the film keeps
                 its play/pause state. Seeks are coalesced to one per frame
                 while dragging (fastSeek where supported — Safari — for
                 cheap keyframe seeks), exact currentTime on release. */
              if (this.hasAttribute('data-video-scrub')) {
                let seekRaf = 0;
                const at = (e) => { const r = bar.getBoundingClientRect(); return Math.max(0, Math.min(1, (e.clientX - r.left) / r.width)); };
                const seekNow = (exact) => {
                  seekRaf = 0;
                  if (scrubTo === null || !(v.duration > 0)) return;
                  const t = Math.min(scrubTo * v.duration, v.duration - 0.1);
                  if (!exact && typeof v.fastSeek === 'function') v.fastSeek(t); else v.currentTime = t;
                };
                bar.addEventListener('pointerdown', (e) => {
                  if (!wrap.classList.contains('is-started') || !(v.duration > 0)) return;
                  e.preventDefault();
                  e.stopPropagation();
                  try { bar.setPointerCapture(e.pointerId); } catch (err) {}
                  wrap.classList.add('is-scrubbing');
                  scrubTo = at(e);
                  paint(scrubTo);
                  seekNow(false);
                });
                bar.addEventListener('pointermove', (e) => {
                  if (scrubTo === null) return;
                  scrubTo = at(e);
                  paint(scrubTo);
                  if (!seekRaf) seekRaf = requestAnimationFrame(() => seekNow(false));
                });
                const end = () => {
                  if (scrubTo === null) return;
                  cancelAnimationFrame(seekRaf);
                  seekNow(true);
                  scrubTo = null;
                  wrap.classList.remove('is-scrubbing');
                };
                bar.addEventListener('pointerup', end);
                bar.addEventListener('pointercancel', end);
                bar.addEventListener('click', (e) => e.stopPropagation());
              }

              /* Control bar: timer, mute (on/off, no volume), full screen. */
              if (this.dataset.videoControls === 'bar') {
                const fmt = (t) => { t = Math.max(0, Math.floor(t || 0)); const h = Math.floor(t / 3600), m = Math.floor((t % 3600) / 60), sec = t % 60; return (h ? h + ':' + String(m).padStart(2, '0') : m) + ':' + String(sec).padStart(2, '0'); };
                const scrim = document.createElement('div');
                scrim.className = 'ai-hero-banner__video-scrim';
                scrim.setAttribute('aria-hidden', 'true');
                wrap.insertBefore(scrim, bar);
                const ctl = document.createElement('div');
                ctl.className = 'ai-hero-banner__video-controls';
                const svg = (cls, d) => '<svg class="' + cls + '" width="20" height="20" viewBox="0 0 24 24" aria-hidden="true" focusable="false">' + d + '</svg>';
                const SPK = '<path d="M4 9h4l5-4v14l-5-4H4z" fill="currentColor"/>';
                const LN = ' fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"';
                ctl.innerHTML = '<span class="ai-hero-banner__video-time" aria-hidden="true">0:00 / 0:00</span><span class="ai-hero-banner__video-ctl-spacer"></span>'
                  + '<button type="button" class="ai-hero-banner__video-btn" data-ctl="mute" aria-label="Mute">' + svg('is-off', SPK + '<path d="M16 8.5a5 5 0 0 1 0 7M18.5 6a8.5 8.5 0 0 1 0 12"' + LN + '/>') + svg('is-on', SPK + '<path d="M16.5 9.5l5 5M21.5 9.5l-5 5"' + LN + '/>') + '</button>'
                  + '<button type="button" class="ai-hero-banner__video-btn" data-ctl="fs" aria-label="Full screen">' + svg('is-off', '<path d="M4 9V4h5M20 9V4h-5M4 15v5h5M20 15v5h-5"' + LN + '/>') + svg('is-on', '<path d="M9 4v5H4M15 4v5h5M9 20v-5H4M15 20v-5h5"' + LN + '/>') + '</button>';
                wrap.appendChild(ctl);
                const time = ctl.querySelector('.ai-hero-banner__video-time');
                const muteBtn = ctl.querySelector('[data-ctl="mute"]'), fsBtn = ctl.querySelector('[data-ctl="fs"]');
                const showTime = (t) => { time.textContent = fmt(t) + ' / ' + fmt(v.duration); };
                onPaint = (f) => { if (scrubTo !== null && v.duration > 0) showTime(f * v.duration); };
                ['timeupdate', 'loadedmetadata', 'durationchange', 'seeked'].forEach((t) => v.addEventListener(t, () => { if (scrubTo === null) showTime(v.currentTime); }));
                showTime(0);
                // playing state for the desktop auto-hide
                const playing = () => wrap.classList.toggle('is-playing', !v.paused && !v.ended);
                ['play', 'pause', 'ended'].forEach((t) => v.addEventListener(t, playing));
                // mute
                const muted = () => { wrap.classList.toggle('is-muted', v.muted); muteBtn.setAttribute('aria-label', v.muted ? 'Unmute' : 'Mute'); };
                v.addEventListener('volumechange', muted); muted();
                muteBtn.addEventListener('click', (e) => { e.stopPropagation(); v.muted = !v.muted; });
                // full screen: the wrap where the Fullscreen API allows it (desktop, Android, iPad); Apple's player on iPhone
                const fsEl = () => document.fullscreenElement || document.webkitFullscreenElement || null;
                const canWrap = !!(document.fullscreenEnabled || document.webkitFullscreenEnabled) && !!(wrap.requestFullscreen || wrap.webkitRequestFullscreen);
                const fsSync = () => { const on = fsEl() === wrap; wrap.classList.toggle('is-fullscreen', on); fsBtn.setAttribute('aria-label', on ? 'Exit full screen' : 'Full screen'); };
                document.addEventListener('fullscreenchange', fsSync); document.addEventListener('webkitfullscreenchange', fsSync);
                const toggleFs = () => {
                  if (fsEl() === wrap) { (document.exitFullscreen || document.webkitExitFullscreen).call(document); return; }
                  if (canWrap) { const r = (wrap.requestFullscreen || wrap.webkitRequestFullscreen).call(wrap); if (r && r.catch) r.catch(() => {}); }
                  else if (v.webkitEnterFullscreen) { try { v.webkitEnterFullscreen(); } catch (err) {} }
                };
                if (!canWrap && !v.webkitEnterFullscreen) fsBtn.hidden = true;
                fsBtn.addEventListener('click', (e) => { e.stopPropagation(); toggleFs(); });
                // desktop: show on mouse movement, hide after 2.5s of stillness while playing
                let hideT = 0;
                const poke = () => { wrap.classList.add('controls-on'); clearTimeout(hideT); hideT = setTimeout(() => wrap.classList.remove('controls-on'), 2500); };
                wrap.addEventListener('pointermove', (e) => { if (e.pointerType === 'mouse') poke(); });
                wrap.addEventListener('pointerleave', (e) => { if (e.pointerType === 'mouse') { clearTimeout(hideT); wrap.classList.remove('controls-on'); } });
                v.addEventListener('play', poke);
                // keyboard on the focused film: M = mute, F = full screen
                wrap.addEventListener('keydown', (e) => {
                  if (e.target !== wrap) return;
                  if (e.key === 'm' || e.key === 'M') { e.preventDefault(); v.muted = !v.muted; poke(); }
                  if (e.key === 'f' || e.key === 'F') { e.preventDefault(); toggleFs(); }
                });
              }
            }
          });
        }

        this.hoverZone = this.querySelector('[data-hover-zone]');
        this.content = this.querySelector('[data-content]');
        this.background = this.querySelector('[data-background]');
        this.subheading = this.querySelector('[data-subheading]');
        this.headline = this.querySelector('[data-headline]');
        this.body = this.querySelector('[data-body]');
        this.link = this.querySelector('[data-link]');
        this.classList.toggle('has-link', !!this.link);
        this.expander = this.querySelector('[data-expander]');
        if (this.dataset.stickyText !== 'false' && this.content) registerLift(this);

        // Click anywhere on the hero to open the link (desktop + mobile)
        this.addEventListener('click', (e) => {
          if (!this.link) return;
          if (e.target.closest('[data-link]')) return;
          // Clicks on a video with native controls (click-to-play) must reach
          // the native controls instead of opening the link. Autoplay videos
          // have no controls — those should still navigate like the rest of
          // the hero.
          const clickedVideo = e.target.closest('video');
          if (clickedVideo && clickedVideo.hasAttribute('controls')) return;
          if (this.dataset.videoLabel === 'text' && e.target.closest('[data-video-wrap]')) return;

          // Don't navigate if the user has a text selection (they're copying text)
          const sel = window.getSelection && window.getSelection();
          if (sel && sel.toString().length > 0) return;

          // On mobile with body text, the text block tap-toggles the expander
          if (window.innerWidth < 990 && this.body && e.target.closest('[data-content]')) return;

          e.preventDefault();
          this.openLink_();
        });

        setTimeout(() => this.updatePositions(), 100);
        this.sizeSig_ = window.innerWidth + 'x' + this.offsetWidth + 'x' + this.offsetHeight;
        resizeHeroes.add(this); // shared, frame-coalesced; see runResize

        // Hover state is a composite of two independent triggers: mouse
        // hover over the TEXT BLOCK or its LINK, and a desktop scroll-
        // position trigger (analogous to mobile). Either being true
        // engages .hover-active. The bottom-strip hover-zone NO LONGER
        // toggles state — we deliberately removed its mouseenter/leave
        // listeners. The hover-zone element remains in the DOM because
        // video-engaged CSS targets it and clicks bubble through it.
        this.isHovering = false;
        this.isScrollActive = false;
        const updateHoverActive = () => {
          this.classList.toggle('hover-active', this.isHovering || this.isScrollActive);
        };
        const setHover = (on) => {
          this.isHovering = on;
          updateHoverActive();
        };

        const syncHover = () => {
          const overLink = this.link && this.link.matches(':hover');
          const overContent = this.content && this.content.matches(':hover');
          setHover(!!(overLink || overContent));
        };

        if (this.link) {
          this.link.addEventListener('mouseenter', () => setHover(true));
          this.link.addEventListener('mouseleave', () => setTimeout(syncHover, 0));
        }

        // Content sits above hoverZone (so text is selectable); track hover here too
        // so moving the cursor onto the text doesn't collapse the panel.
        // Desktop only — iOS simulates mouseenter on tap, which would force hover-active
        // and prevent the mobile expander toggle from visually closing.
        if (this.content) {
          this.content.addEventListener('mouseenter', () => {
            if (window.innerWidth >= 990) setHover(true);
          });
          this.content.addEventListener('mouseleave', () => {
            if (window.innerWidth >= 990) setTimeout(syncHover, 0);
          });
        }

        // Click handler — when body text exists, tapping the content area
        // toggles the FULL expand state (.mobile-expanded), which reveals
        // the body and rotates the + icon. The scroll-position handler
        // below is independent and only engages the BACKGROUND.
        if (this.body && this.content) {
          this.content.addEventListener('click', (e) => {
            if (e.target.closest('[data-link]')) return;
            if (window.innerWidth < 990) {
              this.setMobileExpanded_(!this.isMobileExpanded);
            }
          });
        }

        // Mobile scroll-position-driven BACKGROUND-ONLY reveal. ALWAYS runs
        // (regardless of body presence). Toggles .mobile-bg-engaged when
        // the text block's centre crosses 45% from the viewport top. This
        // is independent of .mobile-expanded — both can coexist:
        //  • Scroll past threshold → .mobile-bg-engaged: background up,
        //    colours shift, link arrow shows. Body stays hidden, + stays +.
        //  • Click + (body case)    → .mobile-expanded: body reveals, + rotates.
        //  • Scroll back            → .mobile-bg-engaged removed; if also
        //    not .mobile-expanded, background slides back down.
        const mobileTextEl = this.content || this.headline || this;
        const mobileBgScrollUpdate = () => {
          if (window.innerWidth >= 990) {
            if (this.classList.contains('mobile-bg-engaged')) {
              this.classList.remove('mobile-bg-engaged');
            }
            return;
          }
          const rect = mobileTextEl.getBoundingClientRect();
          const vh = window.innerHeight || document.documentElement.clientHeight;
          const textCenter = rect.top + rect.height / 2;
          const threshold = vh * 0.45;
          this.classList.toggle('mobile-bg-engaged', textCenter < threshold);
        };
        window.addEventListener('scroll', mobileBgScrollUpdate, { passive: true });
        (this.scrollChecks_ || (this.scrollChecks_ = [])).push(mobileBgScrollUpdate);
        mobileBgScrollUpdate();

        // Desktop scroll-position-driven background reveal — mirrors the
        // mobile no-body version above but ALWAYS active on desktop
        // (regardless of body presence). .hover-active is set when the
        // text block's centre crosses 45% from the viewport top. It
        // composes with mouse-hover via updateHoverActive, so either
        // trigger keeps the panel engaged and releasing one doesn't
        // collapse the panel if the other is still true. No-op below
        // 990px — the mobile branches above own that range.
        {
          const textEl = this.content || this.headline || this;
          const desktopScrollUpdate = () => {
            if (window.innerWidth < 990) {
              if (this.isScrollActive) {
                this.isScrollActive = false;
                updateHoverActive();
              }
              return;
            }
            const rect = textEl.getBoundingClientRect();
            const vh = window.innerHeight || document.documentElement.clientHeight;
            const textCenter = rect.top + rect.height / 2;
            const threshold = vh * 0.45;
            this.isScrollActive = textCenter < threshold;
            updateHoverActive();
          };
          window.addEventListener('scroll', desktopScrollUpdate, { passive: true });
          (this.scrollChecks_ || (this.scrollChecks_ = [])).push(desktopScrollUpdate);
          desktopScrollUpdate();
        }
      }

      openLink_() {
        if (!this.link) return;
        const href = this.link.getAttribute('href');
        if (!href) return;
        const newTab = this.link.getAttribute('target') === '_blank';
        if (newTab) {
          window.open(href, '_blank', 'noopener,noreferrer');
        } else {
          window.location.href = href;
        }
      }

      // Sticky text: park the text so its TOP sits at 45% of the hero until it
      // pins (--hero-rest = 55% of hero height minus the visible text height).
      setRest_(visibleTextHeight) {
        const rest = Math.max(0, Math.round(this.offsetHeight * 0.55 - Math.max(0, visibleTextHeight)));
        this.style.setProperty('--hero-rest', rest + 'px');
        this.style.setProperty('--hero-h', (Math.round(this.getBoundingClientRect().height * 100) / 100) + 'px'); // exact: a rounded height left up to 0.5px between text and bar
        if (PIN_INSET_RATIO) this.style.setProperty('--hero-pin-inset', pinInsetFor(this.offsetHeight) + 'px');
        else this.style.removeProperty('--hero-pin-inset');
        scheduleLifts();
      }
      setMobileExpanded_(expanded) {
        if (this.isMobileExpanded === expanded) return;
        this.isMobileExpanded = expanded;
        this.classList.toggle('mobile-expanded', expanded);
        if (this.expander) {
          this.expander.setAttribute('aria-expanded', expanded);
          this.expander.setAttribute('aria-label', expanded ? 'Collapse content' : 'Expand content');
        }
        setTimeout(() => this.updatePositions(), 50);
      }

      updatePositions() {
        if (window.innerWidth >= 990) {
          if (this.content && this.hoverZone && this.background) {
            const linkH = this.link ? this.link.offsetHeight : 0;
            this.content.style.setProperty('--ai-link-h', linkH + 'px');

            let bodyRestHeight = 0;
            if (this.body) {
              const bodyStyles = window.getComputedStyle(this.body);
              const bodyFontSize = parseFloat(bodyStyles.fontSize);
              const bodyLineHeight = parseFloat(bodyStyles.lineHeight);
              const bodyPaddingTop = parseFloat(bodyStyles.paddingTop);
              const firstLineHeight = bodyLineHeight || (bodyFontSize * 1.5);
              bodyRestHeight = this.body.offsetHeight - firstLineHeight - bodyPaddingTop;
            }

            const linkGapNudge = this.link ? (this.body ? 14 : 0) : 0;

            if (!this.isHovering) {
              this.content.style.transform = `translateY(${bodyRestHeight + linkGapNudge}px)`;
            } else {
              this.content.style.transform = `translateY(0)`;
            }

            const contentHeight = this.content.offsetHeight;
            this.setRest_(contentHeight - bodyRestHeight);
            this.background.style.height = contentHeight + 'px';
            this.background.style.width = (this.content.offsetLeft + this.content.offsetWidth) + 'px';

            const containerRect = this.getBoundingClientRect();
            const contentRect = this.content.getBoundingClientRect();
            // The text layer may be lifted at this moment (docked while the
            // hero is still entering); measure the hover zone as if it were
            // not, or the zone grows by the lift and covers the picture or
            // film above the text. Works for every pin engine.
            const pinLayer = this.querySelector('[data-pin]');
            const pinShift = pinLayer ? pinLayer.getBoundingClientRect().bottom - containerRect.bottom : 0;
            const hoverZoneHeight = containerRect.bottom - (contentRect.top - pinShift) + bodyRestHeight;
            this.hoverZone.style.height = Math.max(hoverZoneHeight, 100) + 'px';
          }
        } else {
          if (this.background && this.content) {
            const linkH = this.link ? this.link.offsetHeight : 0;
            this.content.style.setProperty('--ai-link-h', linkH + 'px');
            const bodyHeight = this.body ? this.body.scrollHeight : 0;

            // Expose bodyHeight as a CSS variable so the .mobile-bg-engaged
            // rule can shift the background down by that amount when only
            // the background is engaged (no body expansion). Read inside
            // .ai-hero-banner.mobile-bg-engaged:not(.mobile-expanded)
            // .ai-hero-banner__background { transform: translateY(var(--mobile-body-h)) }
            this.style.setProperty('--mobile-body-h', bodyHeight + 'px');

            if (!this.isMobileExpanded) {
              this.content.style.transform = `translateY(${bodyHeight}px)`;
            } else {
              this.content.style.transform = `translateY(0)`;
            }

            const contentHeight = this.content.scrollHeight;
            this.background.style.height = contentHeight + 'px';
            this.background.style.width = '100%';
            this.setRest_(contentHeight - bodyHeight);
          }
        }
      }
    }

    const _define = () => customElements.define('edge-to-edge-hero', EdgeToEdgeHero);
    if ('requestIdleCallback' in window) {
      requestIdleCallback(_define);
    } else {
      setTimeout(_define, 100);
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
